import clone from 'ramda/src/clone'
import { ACTION_TYPES, STATE_TYPES } from '@/utils/bot-json.constants'

const ANSWER_REF_REGEX = /ref:answer:([^"]+)/g

export function inlineTemplate(hostJson, templateId, templateJson) {
  const inlined = clone(hostJson)
  if (!inlined.actions) inlined.actions = {}
  if (!inlined.postbacks) inlined.postbacks = {}

  const fromTemplate = `ref:template:${templateId}`
  const templateStates = templateJson?.states || {}
  const templateActions = templateJson?.actions || {}
  const templatePostbacks = templateJson?.postbacks || {}

  for (const [stateId, state] of Object.entries(inlined.states || {})) {
    if (state.type !== STATE_TYPES.TEMPLATE_REF || state.fromTemplate !== fromTemplate) continue

    const templateState = templateStates[state.templateState]
    if (!templateState) {
      throw new Error(`Template state "${state.templateState}" not found for templateRef "${stateId}"`)
    }

    const suffix = state.postbackSuffix || ''
    const newState = clone(templateState)
    newState.transitions = [...(state.templateTransitions || []), ...(state.transitions || [])]
    delete newState.templateTransitions
    if (newState.conditionEndState && templateStates[newState.conditionEndState]) {
      newState.conditionEndState = newState.conditionEndState + suffix
    }
    if (state.requestOutcome) newState.requestOutcome = state.requestOutcome

    if (Array.isArray(newState.actions)) {
      newState.actions = newState.actions.map(actionId => {
        const newActionId = actionId + suffix
        const templateAction = templateActions[actionId]
        if (!templateAction) {
          throw new Error(`Template action "${actionId}" not found for templateRef "${stateId}"`)
        }
        if (!inlined.actions[newActionId]) {
          inlined.actions[newActionId] = suffixPostbacksInAction(clone(templateAction), suffix)
        }
        copyTemplatePostbacks(inlined.postbacks, templatePostbacks, templateAction, suffix)
        return newActionId
      })
    }

    delete newState.fromTemplate
    delete newState.templateState
    delete newState.postbackSuffix
    inlined.states[stateId] = newState
  }

  return inlined
}

export function collectAnswerRefCreates(templateJson) {
  return findAnswerRefIds(templateJson)
}

export function findAnswerRefIds(convJson) {
  const ids = new Set()
  const matches = Array.from(JSON.stringify(convJson || {}).matchAll(ANSWER_REF_REGEX))
  matches.forEach(match => ids.add(match[1]))
  return Array.from(ids)
}

function suffixPostbacksInAction(action, suffix) {
  if (!suffix || action.type === ACTION_TYPES.VALIDATION) return action

  const content = action.content
  if (!content) return action

  const structures = Array.isArray(content.payload) ? content.payload : [content.payload]
  for (const structure of structures) {
    if (!structure?.buttons) continue
    for (const button of structure.buttons) {
      if (button.type === 'postback' && button.payload) {
        button.payload = button.payload + suffix
      }
    }
  }

  if (action.id) action.id = action.id + suffix
  return action
}

function copyTemplatePostbacks(hostPostbacks, templatePostbacks, templateAction, suffix) {
  const content = templateAction.content
  if (!content) return

  const structures = Array.isArray(content.payload) ? content.payload : [content.payload]
  for (const structure of structures) {
    if (!structure?.buttons) continue
    for (const button of structure.buttons) {
      if (button.type !== 'postback' || !button.payload) continue
      const originalKey = button.payload
      const suffixedKey = originalKey + suffix
      if (hostPostbacks[suffixedKey] != null) continue
      const postbackValue = templatePostbacks[originalKey]
      if (postbackValue == null) continue
      hostPostbacks[suffixedKey] = typeof postbackValue === 'string' && postbackValue.startsWith('ref:') ?
        postbackValue :
        postbackValue + suffix
    }
  }
}
